/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The active tier of a `Course`.
 */
export const CourseTier = /* #__PURE__ */ parsers.exactly('advanced', 'starter', 'free');
